// extracted by mini-css-extract-plugin
export default {"merchantDetailsUpdate":"MerchantDetailsUpdate_merchantDetailsUpdate__1iJYL","merchantDetailsCardWrapper":"MerchantDetailsUpdate_merchantDetailsCardWrapper__IXeDs"};